class LayerCircles {
	

	
	constructor(du, scenario, tc) {
		
		this.scenario = scenario;
		this.map = du.map;
		this.du = du;
		this.tc = tc;
		//this.placeTurbines();
		this.currentCircle = false;
		this.currentCircleIdx = false;
		
	}
	
	
		
}

LayerCircles.layerId = 'circles_';
LayerCircles.textLayerId = 'circles_name_';
LayerCircles.sourceId = 'circles_source_';


export default LayerCircles;